export default __webpack_public_path__ + "static/team-7c59bdcd4ef46727f71f29bcfad26d43.jpg";